module.exports = [{"name":"MTN","prefixes":[],"requireToken":false},{"name":"Airtel","prefixes":[],"requireToken":false},{"name":"Glo","prefixes":[],"requireToken":false},{"name":"Etisalat","prefixes":[],"requireToken":false}]


//////////////////
// WEBPACK FOOTER
// ./src/views/Request/MobileNetworks.json
// module id = 824
// module chunks = 0